export default __webpack_public_path__ + "static/media/brightGradation.d8238afd.webp";